import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { useQuery } from '@tanstack/react-query';
import { getSingleCategory } from '@dealstack/frontend/app/services/Blog.service.ts';
import { ApplicationType } from '@dealstack/shared/lib/generated';
import type { ClientPerspective } from '@sanity/client';

export const useSingleCategory = (
	dataset: ApplicationType,
	slug: string | undefined,
	perspective?: ClientPerspective
) => {
	const request = useQuery({
		queryKey: [
			API_PATHS.HELP_BLOG_DATASET_CATEGORIES_SLUG_GET,
			{ dataset, slug: slug || '', perspective },
		],
		queryFn: () =>
			getSingleCategory(API_PATHS.HELP_BLOG_DATASET_CATEGORIES_SLUG_GET, {
				dataset,
				slug: slug || '',
				perspective,
			}),
		enabled: !!slug,
	});

	return {
		category: request.data,
		isFetching: request.isFetching,
		error: request.error,
	};
};
